import React from "react";

interface SplitPathIconProps {
    className?: string;
}

/**
 * Split-path glyph — one path diverging into two. Marks the "your USDv
 * could also go elsewhere" row in the positions breakdown.
 *
 * LOCAL STOPGAP. Icons belong in `@solomon-labs/design`
 * (`components/icons`) — this one has not shipped there yet, and the
 * vendored package is refreshed wholesale by
 * `yarn dependencies:sync:design`, so hand-adding it there would be
 * overwritten. When it lands in the design system, delete this file and
 * import `SplitPathIcon` from `@solomon-labs/design/components/icons`
 * instead.
 *
 * Follows the design system's icon contract so the swap is a one-line
 * import change: monochrome, paints with `currentColor` (the Figma
 * export hardcoded `#1B1C20`, which would have ignored the surrounding
 * text color), and takes its size from the box via a Tailwind `size-*`
 * class.
 */
export function SplitPathIcon({
    className
}: SplitPathIconProps): React.ReactElement {
    return (
        <svg
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden
        >
            <path
                d="M6.00064 3.99666L6.49663 4.49221L7.99731 2.9911L9.49842 4.49221L9.99441 3.99666L7.99731 2L6.00064 3.99666Z"
                fill="currentColor"
            />
            <path
                d="M12.0994 7.96202L11.4215 7.78005L11.9718 5.72758L9.91896 5.17752L10.1003 4.49945L12.8311 5.23147L12.0994 7.96202Z"
                fill="currentColor"
            />
            <path
                d="M3.90169 7.96202L4.5796 7.78005L4.02932 5.72758L6.08217 5.17752L5.9008 4.49945L3.17004 5.23147L3.90169 7.96202Z"
                fill="currentColor"
            />
            <path
                d="M8.38064 3.75V9.75H7.62064V3.75H8.38064Z"
                fill="currentColor"
            />
            <path
                d="M7.62064 13.9998H8.38064V8.84982C8.38064 8.69458 8.45275 8.60435 8.57581 8.50971L11.4806 6.5L11.1006 5.82L7.83498 7.95061C7.7007 8.04409 7.62064 8.19736 7.62064 8.36097V13.9998Z"
                fill="currentColor"
            />
            <path
                d="M8.37823 14H7.61823L7.61823 8.85006C7.61823 8.69482 7.54612 8.6046 7.42307 8.50996L4.52061 6.50004L4.90061 5.82L8.16389 7.95087C8.29818 8.04435 8.37823 8.19761 8.37823 8.36123V14Z"
                fill="currentColor"
            />
        </svg>
    );
}
